import { createTheme } from '@mui/material';
import merge from 'lodash/merge';
import pick from 'lodash/pick';
import { customerThemeOptions, professionalThemeOptions, } from './theme';
import { ThemeDatepicker } from './theme/components/datepicker';
export const professionalThemeOptionsWithDatepicker = merge({}, professionalThemeOptions, {
    components: Object.assign({}, ThemeDatepicker),
});
export const customerThemeOptionsWithDatepicker = merge({}, customerThemeOptions, {
    components: Object.assign({}, ThemeDatepicker),
});
export const professionalThemeWithDatepicker = createTheme(professionalThemeOptionsWithDatepicker);
export const customerThemeWithDatepicker = createTheme(customerThemeOptionsWithDatepicker);
export const getPartialProfessionalThemeWithDatepicker = (...pickedKeys) => createTheme(Object.assign(Object.assign({}, professionalThemeOptions), { components: pick(Object.assign(Object.assign({}, professionalThemeOptions.components), ThemeDatepicker), pickedKeys) }));
export const getPartialCustomerThemeWithDatepicker = (...pickedKeys) => createTheme(Object.assign(Object.assign({}, customerThemeOptions), { components: pick(Object.assign(Object.assign({}, customerThemeOptions.components), ThemeDatepicker), pickedKeys) }));
